import { useQuery } from '@apollo/client';
import { ACTIVE_PHARMACY_VACATIONS } from '../pharmacyTypeDefs';

export const useQueryActivePharmacyVacations = (options?: any): any =>
  useQuery(ACTIVE_PHARMACY_VACATIONS, options);

